import { Dispatch } from "../../controller";
import { Model,StateProps } from "../../model";
import { MeioPag, Pessoa,TabelaPrecoConfig,TipoPessoa } from "../../data.types";

export interface Cliente extends Pessoa {
    info_dt_validade_item:boolean//se é obrigatorio informar data de validade do vazo no momento da movimentacao
    revenda:boolean//se é um cliente revendedor
    tabela_preco_padrao?: TabelaPrecoConfig
    meio_pag_default?: MeioPag;
}

export interface ClienteState extends StateProps<Cliente> {
 
}

export interface ClienteActions extends Dispatch<Cliente> {

}

const model = new Model<Pessoa,ClienteState>(TipoPessoa.cliente);

const intialValueCliente:Cliente = {
    ...model.getInitialValue(),
    type:TipoPessoa.cliente,
    apelido:"",
    nome:"",
    sobrenome:"",
    email:"",
    tipo_doc:"CPF",
    enderecos:[],
    idx_endereco_main:0,
    fone:"",
    n_doc:"",
    senha:"",
    whatsapp:"",
    revenda:false,
    info_dt_validade_item:true,
    meio_pag_default:undefined,
    ativo:true,
    tabela_preco_padrao:undefined
}

export const initialValueState:ClienteState = {
    ...model.getInititalValueState(),
    row:intialValueCliente,
}


